import { ElementType, HTMLAttributes, ReactNode } from "react";
import "./../../globals.scss";
import styles from "./EyebrowLabel.module.scss";

export interface EyebrowLabelProps extends HTMLAttributes<HTMLElement> {
  /** Defaults to a span; pass "h2"/"h3" when the label is the section heading. */
  as?: ElementType;
  children: ReactNode;
}

/** Small uppercase label that sits above a value or a group of content. */
export function EyebrowLabel({
  as: Tag = "span",
  className,
  children,
  ...props
}: EyebrowLabelProps) {
  return (
    <Tag className={`${styles.eyebrow} ${className ?? ""}`} {...props}>
      {children}
    </Tag>
  );
}
